"use client";

import { useQueryClient } from "@tanstack/react-query";
import { gql } from "graphql-request";
import { useGraphqlMutation } from "@/lib/graphql/useGraphql";
import type { AutoRechargeSettings } from "./useBillingOverview";

type UpdateAutoRechargeData = {
  updateAutoRecharge: AutoRechargeSettings;
};

export type UpdateAutoRechargeVariables = {
  enabled: boolean;
  // Micro-USD values are strings to avoid GraphQL's 32-bit Int overflow.
  threshold_micro?: string | null;
  target_micro?: string | null;
  monthly_limit_micro?: string | null;
};

const updateAutoRechargeDocument = gql`
  mutation UpdateAutoRecharge(
    $enabled: Boolean!
    $threshold_micro: BigInt
    $target_micro: BigInt
    $monthly_limit_micro: BigInt
  ) {
    updateAutoRecharge(
      enabled: $enabled
      threshold_micro: $threshold_micro
      target_micro: $target_micro
      monthly_limit_micro: $monthly_limit_micro
    ) {
      enabled
      threshold_micro
      target_micro
      monthly_limit_micro
    }
  }
`;

export const useAutoRecharge = () => {
  const queryClient = useQueryClient();

  return useGraphqlMutation<UpdateAutoRechargeData, UpdateAutoRechargeVariables>({
    mutationKey: ["update-auto-recharge"],
    document: updateAutoRechargeDocument,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["billing-overview"] });
    },
  });
};
